import React from 'react';

import {Anchor, Button} from '@newsela/angelou';
import {cx} from 'emotion';
import PropTypes from 'prop-types';

import withTrackEvent from 'static/three-oh/src/components/with/WithTrackEvent';

import {ReactComponent as CleverSvg} from '../assets/CleverSSO.svg';
import styles from '../styles';

const propTypes = {
  actionName: PropTypes.string,
  additionalClassName: PropTypes.string,
  anchorText: PropTypes.string.isRequired,
  ariaProps: PropTypes.object,
  href: PropTypes.string.isRequired,
  iconClassName: PropTypes.string,
  eventProperties: PropTypes.object,
  legacyEventName: PropTypes.string,
  streamProperties: PropTypes.object,
};


const AnchorWithTrackEvent = withTrackEvent(Anchor);

const CleverAnchor = ({
  actionName,
  additionalClassName,
  anchorText,
  ariaProps,
  href,
  iconClassName,
  eventProperties,
  legacyEventName,
  streamProperties,
}) => {
  return (
    <AnchorWithTrackEvent
      href={href}
      additionalClassName={additionalClassName}
      styleAnchorAsButton={{
        flavor: Button.flavor.solid,
        statusColor: Button.statusColor.primary,
        size: Button.size.justified
      }}
      __css={`
        background-color: ${styles.cleverBrandColor};
        &:hover, &:focus {
          background: linear-gradient(0deg, rgba(29, 29, 29, 0.15), rgba(29, 29, 29, 0.15)), ${styles.cleverBrandColor};
        }
        padding-left: 0.3rem;
        &[disabled] {
          background-color: ${styles.cleverBrandColor};
        }
      `}
      ariaProps={ariaProps}
      dataProps={{
        'data-qa-selector': 'clever_link',
        id: 'clever_link'
      }}
      objectType="User"
      actionName={actionName}
      eventProperties={eventProperties}
      legacyEventName={legacyEventName}
      streamProperties={streamProperties}
    >
      <div className={styles.socialLinkDescription}>
        <CleverSvg
          aria-hidden="true"
          className={cx([styles.cleverIcon, iconClassName])}
        />
        <span className={styles.linkLabel}>{anchorText}</span>
      </div>
    </AnchorWithTrackEvent>
  );
};

CleverAnchor.propTypes = propTypes;

export default CleverAnchor;
